export enum NotificationsTabEnum {
  meteo = 'meteo',
}
